import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const useRatingStarsStyles = makeStyles()((theme: Theme) => ({
	buttonsWrapper: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-evenly",
		gap: theme.spacing(7),
		marginBottom: theme.spacing(5),
	},
	iconButton: {
		boxShadow: "0px 4px 10px #D2D9E4",
		width: theme.spacing(9),
		height: theme.spacing(9),
	},
	iconButtonActive: {
		boxShadow: "0px 4px 10px #D2D9E4, inset 0 0 0 2px #5566E0",
	},
	likeIcon: {
		marginBottom: theme.spacing(0.75),
	},
	dislike: {
		transform: "rotate(180deg)",
		marginBottom: theme.spacing(-0.75),
	},
}));
